export default __webpack_public_path__ + "static/media/icons_add_new.4ef70105.svg";